export enum ManageUsersStoreStatus {
  Loading = 'Loading',
  Updating = 'Updating',
}
